import React from 'react'
import { connect } from 'react-redux'
import ContactRecordLite from 'components/shared/ContactRecordLite'
import { EndUser } from 'app/modules/endUser/models'
import * as EndUserSelectors from 'app/modules/endUser/selectors'

const PresenceContactRecordLite = ({ user, endUser, ...props }) => (
  <ContactRecordLite
    user={endUser}
    userStatus={user && {
      lastUpdatedAt: user.updatedAt,
      geo: user.location,
    }}
    {...props}
  />
)

const makeMapStateToProps = () => {
  const endUserSelector = EndUserSelectors.makeEndUserSelector()
  return (state, props) => {
    const endUserId = props.user && props.user.getIn(['endUserId'])
    const endUser = endUserId && endUserSelector(state, { id: endUserId })
    return {
      endUser: endUser || new EndUser({id: endUserId}),
    }
  }
}

export default connect(makeMapStateToProps)(PresenceContactRecordLite)



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/ContactInfo/index.js